export default "__VITE_ASSET__BXrqn0Sr__"